module.exports = __webpack_public_path__ + "static/media/business-dark.8a234b50.svg";